import { createAction } from "redux-actions";
import { SET_EXT, CLEAN_NAV } from "../../constants/index";

export const setFromPlatform = createAction(SET_EXT, (data) => data);

export const cleanNav = createAction(CLEAN_NAV, () => {});
